/* unplugin-vue-components disabled */import script from "./ComplaintComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplaintComponents.vue?vue&type=script&setup=true&lang=js"

import "./ComplaintComponents.vue?vue&type=style&index=0&id=3215a6bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3215a6bb"]])

export default __exports__